// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/assets/images/contact_abb_bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-abb {
  position: relative;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/cover no-repeat;
}
.contact-abb .background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.contact-abb .contact-abb-container {
  position: relative;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
  margin: 0 8%;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: center;
  top: 10%;
  gap: 20px;
}
.contact-abb .contact-abb-container .contact-abb-image {
  max-width: 100%;
  border-radius: 10px;
}
.contact-abb .contact-abb-container .contact-abb-card-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: space-around;
}
.contact-abb .contact-abb-container .contact-abb-card-list .contact-abb-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  background: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: background 0.3s;
}
.contact-abb .contact-abb-container .contact-abb-card-list .contact-abb-card:hover {
  background: #e6e6e6;
}
.contact-abb .contact-abb-container .contact-abb-card-list .contact-abb-card span {
  flex: 1 1;
  text-align: left;
  margin-left: 10px;
  font-size: 16px;
  font-weight: 500;
}
.contact-abb .contact-abb-container .contact-abb-card-list .contact-abb-card .image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  line-height: 0;
}
.contact-abb .contact-abb-close-button {
  position: absolute;
  bottom: 20px;
  right: 20px;
  background-color: #36f;
  border: 2px solid #36f;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-size: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  transition: background 0.3s;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/contact_abb.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0EAAA;AACF;AACE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AACJ;AAGE;EACE,kBAAA;EACA,UAAA;EACA,8BAAA;EAEA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAFJ;AAKI;EACE,eAAA;EACA,mBAAA;AAHN;AAMI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,6BAAA;AAJN;AAMM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,2BAAA;AAJR;AAMQ;EACE,mBAAA;AAJV;AAOQ;EACE,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AALV;AAOQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AALV;AAWE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,wCAAA;EACA,2BAAA;AATJ","sourcesContent":[".contact-abb {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: url(\"../../../public/assets/images/contact_abb_bg.svg\") center/cover no-repeat;\r\n// display: flex;\r\n  .background-overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    \r\n  }\r\n\r\n  .contact-abb-container {\r\n    position: relative;\r\n    z-index: 1;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    // max-width: 70%;\r\n    margin: 0 8%;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n    text-align: center;\r\n    top: 10%;\r\n    gap: 20px;\r\n    // justify-content: center;\r\n\r\n    .contact-abb-image {\r\n      max-width: 100%;\r\n      border-radius: 10px;\r\n    }\r\n\r\n    .contact-abb-card-list {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 20px;\r\n      justify-content: space-around;\r\n\r\n      .contact-abb-card {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        padding: 15px 20px;\r\n        background: #f5f5f5;\r\n        border-radius: 8px;\r\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n        cursor: pointer;\r\n        transition: background 0.3s;\r\n\r\n        &:hover {\r\n          background: #e6e6e6;\r\n        }\r\n\r\n        span {\r\n          flex: 1;\r\n          text-align: left;\r\n          margin-left: 10px;\r\n          font-size: 16px;\r\n          font-weight: 500;\r\n        }\r\n        .image-container {\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: center;\r\n          background-color: #fff;\r\n          width: 50px;\r\n          height: 50px;\r\n          border-radius: 50%; \r\n          line-height: 0;\r\n      }\r\n      }\r\n    }\r\n  }\r\n\r\n  .contact-abb-close-button {\r\n    position: absolute;\r\n    bottom: 20px;\r\n    right: 20px;\r\n    background-color: #36f;\r\n    border: 2px solid #36f;\r\n    color: #fff;\r\n    padding: 10px 20px;\r\n    border: none;\r\n    border-radius: 25px;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\r\n    transition: background 0.3s;\r\n  }\r\n}\r\n\t"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
